module.exports = __webpack_public_path__ + "img/SELO_7_ANOS_2022_RGB-02.e246e88b.webp";